<template>
    <el-card v-for="(item, index) in relation_list" :key="index" style="padding-bottom: 2rem;">
        <el-row justify="space-evenly">
            <el-col :span="24">
                <h2 style="margin-top:0;margin-bottom: 1rem;">{{ item.title }}</h2>
            </el-col>
            <el-col :span="4">
                <el-avatar :src="item.img1" :size="120" />
                <div style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.name1 }}</div>
                <div style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.age1 }}</div>
                <div style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.summary1 }}</div>
            </el-col>
            <el-col :span="8">
                <p style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.impression1 }}</p>
                <p style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">⇌</p>
                <p style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.impression2 }}</p>
            </el-col>
            <el-col :span="4">
                <el-avatar :src="item.img2" :size="120" />
                <div style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.name2 }}</div>
                <div style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.age2 }}</div>
                <div style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.summary2 }}</div>
            </el-col>
            <el-col :span="24">
                <p style="font-size:clamp(1rem,1.5vw,2rem);text-align: center;">{{ item.summary }}</p>
            </el-col>
            <el-col :span="24">
                <el-collapse v-model="item.collapse">
                    <el-collapse-item>
                        <template #title="{ isActive }">
                            <span :style="{
                                fontSize: 'clamp(1rem,1.5vw,2rem)',
                                color: isActive ? 'skyblue' : 'slategray'
                            }">
                                服设[展开]
                            </span>
                        </template>
                        <el-row>
                            <template v-for="c, index in item.closet">
                                <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6"
                                    style="display: flex; flex-wrap: wrap;">
                                    <el-card shadow="hover" :body-style="{ padding: '0px' }">
                                        <el-image shadow="hover" style="width: 100%" :src="c" :zoom-rate="1.2"
                                            :preview-src-list="item.closet" show-progress :initial-index="index"
                                            :max-scale="7" :min-scale="0.2" fit="cover" />
                                    </el-card>
                                </el-col>
                            </template>
                        </el-row>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
    </el-card>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { Waterfall, LazyImg } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import service from '../utils/request.js'
import { useCache } from '../utils/usecache.js'

let route = useRoute()
const title = route.params.title[0]
const subtitle = ref("")
let router = useRouter()
const current_page_name = router.currentRoute.value.name
const suffixes = ['.jpg', '.jpeg', '.png', '.gif']
const relation = ref()
const relation_list = ref([])

const showPreview = ref(false)
const showIndex = ref(0)

const impression1 = "A对B的印象"
const impression2 = "B对A的印象"

const prop = defineProps({
    subtitle: {
        type: String,
        default: ""
    },
    charas: {
        type: Array,
        default: []
    },
    relationList: {
        type: String,
        default: []
    }
})

const breakpoints = {
    10000: { //当屏幕宽度小于等于1200
        rowPerView: 4,
    },
    700: { //当屏幕宽度小于等于500
        rowPerView: 2,
    }
}

watch(
    () => router.currentRoute.value.name,
    (newValue, oldValue) => {
        if (newValue != oldValue) {
            var new_page = '#' + newValue
            var old_page = '#' + oldValue
            $(new_page).removeClass('page-tab')
            $(new_page).addClass('page-tab-selected')
            $(old_page).removeClass('page-tab-selected')
            $(old_page).addClass('page-tab')
        }
    }
)


const getData = () => {
    relation_list.value = JSON.parse(prop.relationList);
}

// const getData = (name) => {
//     const requestData = {
//         column: 'name',
//         value: name
//     };
//     service.post("/user/chara/listDetail", requestData)
//         .then(res => {
//             const rst = res.data;
//             if (rst.length != 0 && rst[0] != null) {
//                 prop.charas.push(rst[0]);
//             } else {
//                 console.error('返回简介信息为空', error);
//             }
//         }).catch(error => {
//             console.error('获取简介信息失败', error);
//         });
// }

// watch(
//     () => prop.subtitle,
//     (newValue, oldValue) => {
//         if (newValue != oldValue) {
//             let names = newValue.split("&");
//             if (names.length == 2) {
//                 for (let i = 0; i < names.length; i++) {
//                     if (names[i]) {
//                         getData(names[i]);
//                     }
//                 }
//             }
//         }
//     }
// )

const handleClick = (index) => {
    showPreview.value = true
    showIndex.value = index
}

watch(
    () => prop.relationList,
    (newValue, oldValue) => {
        if (newValue != oldValue) {
            getData();
        }
    }
)
</script>
<style scoped>
.page-tab {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: skyblue;
    text-align: center;
    margin-right: 4px;
}

.page-tab a {
    color: white;
}

.page-tab:hover {
    background-color: rgba(135, 206, 235, 0.2);
}

.page-tab:hover a {
    color: skyblue;
}

.page-tab-selected {
    float: left;
    border-top-left-radius: 12px;
    -webkit-border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    -webkit-border-top-right-radius: 12px;
    border-bottom-left-radius: 2px;
    -webkit-border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    -webkit-border-bottom-right-radius: 2px;
    padding: 0.5rem;
    background-color: MediumTurquoise;
    text-align: center;
    margin-right: 4px;
}

.page-tab-selected a {
    color: white;
}

.info {
    background-color: white;
    padding: 2%;
}
</style>
